import Logo from '@assets/images/stakes-icon-fullcolor.png';

export const LogoOnly = ({ style = { height: 'auto' } }: any) => {
    return (
        <img src={Logo} alt='Stakes Logo' style={style}/>
    )
}
